{
  "branding": {
    "frontdesk-attribution": "Com tecnologia FrontDesk+",
    "practice-logo": "Logótipo de {{name}}"
  },
  "validation": {
    "required": "Este campo é obrigatório",
    "invalid-url": "Por favor insira um URL válido",
    "pin-too-short": "O PIN deve ter pelo menos 4 caracteres",
    "pin-default-rejected": "O PIN padrão 0000 não é permitido. Atribua seu próprio PIN.",
    "invalid-kim-address": "Please enter a valid KIM address (e.g. praxis@musterpraxis.kim.telematik)."
  },
  "common": {
    "back": "Voltar",
    "next": "Próximo",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "done": "Concluído",
    "retry": "Tentar novamente",
    "clear": "Limpar",
    "close": "Fechar",
    "verifying": "Verificando...",
    "select": "Selecionar",
    "minutes": "minutos",
    "clock": "",
    "gender": {
      "M": "Masculino",
      "W": "Feminino",
      "D": "Diverso",
      "U": "Desconhecido"
    },
    "insurance": {
      "GKV": "Estatutário",
      "PKV": "Privado",
      "SELFPAY": "Pagamento próprio"
    },
    "scroll-up": "Rolar para cima",
    "scroll-down": "Rolar para baixo"
  },
  "settings": {
    "device-reset": {
      "title": "Repor dispositivo",
      "description": "Remover a ligação ao consultório, as definições e o PIN deste dispositivo.",
      "confirmation": "Será necessário configurar novamente este dispositivo. A configuração SOL e os dados dos pacientes no inSuite permanecerão inalterados.",
      "cancel": "Cancelar",
      "confirm": "Repor agora"
    },
    "title": "Configurações",
    "save": "Guardar",
    "save-success": "Configurações guardadas",
    "save-error": "Falha ao guardar configurações",
    "load-error": "Falha ao carregar configurações",
    "pin": {
      "title": "PIN Necessário",
      "description": "Por favor insira o seu PIN para aceder às configurações.",
      "error": "PIN errado. Por favor tente novamente.",
      "backspace": "Apagar o último dígito"
    },
    "connection": {
      "title": "Conexão",
      "description": "Configurações de conexão para o servidor Doc-Cirrus Bridge",
      "bridge-url": "URL do Bridge",
      "device-name": "Nome do dispositivo",
      "device-name-placeholder": "por ex. Recepção, Sala 1, Quiosque",
      "device-name-hint": "Nome para identificação no dashboard Bridge",
      "kim-address": "Endereço KIM (opcional)",
      "kim-address-placeholder": "praxis@musterpraxis.kim.telematik",
      "kim-address-hint": "This device only. Leave empty to use the practice KIM address.",
      "test": "Testar",
      "success": "Conexão bem-sucedida",
      "error": "Conexão falhada",
      "api-unreachable": "API DocCirrus inacessível",
      "status-title": "Status da conexão",
      "status": {
        "api": "API conectada",
        "ti": "Infraestrutura telemática",
        "card-reader": "Leitor de cartão disponível",
        "medical-card": "Cartão do consultório (SMC-B/HBA)"
      },
      "kim-address-consequence": "At Online Check-in the insurer sends the insured person’s data to this address instead of the practice address.",
      "kim-address-practice": "Practice address",
      "kim-address-confirm-title": "Change the KIM address for this device?",
      "kim-address-confirm-description": "At Online Check-in the insurer will send the insured person’s data to this address from now on.",
      "kim-address-confirm-previous": "Current",
      "kim-address-confirm-next": "New",
      "kim-address-confirm-cancel": "Cancel",
      "kim-address-confirm-accept": "Change address",
      "sol-token": "Token Sol (do inSuite)",
      "sol-token-hint": "Copie-o da administração do Bridge no inSuite. Necessário para a ligação.",
      "sol-token-show": "Mostrar token",
      "sol-token-hide": "Ocultar token",
      "bridge-unreachable": "Bridge inacessível. Verifique o endereço e a porta.",
      "diagnostic-id": "ID de diagnóstico: {{id}}",
      "scan-qr": "Ler código QR",
      "scan-title": "Ler código QR do Bridge",
      "scan-manual": "Introduzir manualmente"
    },
    "terminal": {
      "title": "Leitor de Cartões",
      "description": "Seleção do leitor de cartões para a infraestrutura telemática",
      "select": "Selecionar Terminal",
      "select-placeholder": "Escolher terminal...",
      "loading": "A carregar terminais...",
      "none-available": "Nenhum terminal disponível",
      "none-found": "Nenhum terminal encontrado",
      "found": "{{count}} terminal(is) encontrado(s)",
      "connect-hint": "Conecte-se primeiro ao servidor bridge para carregar os terminais.",
      "found-count": "Leitores de cartões encontrados: {{count}}",
      "refresh": "Recarregar leitores de cartões"
    },
    "practice": {
      "title": "Consultório",
      "description": "Informações sobre o seu consultório",
      "name": "Nome do consultório",
      "name-placeholder": "ex. Dr. João Silva",
      "welcome-message": "Mensagem de Boas-vindas",
      "welcome-placeholder": "ex.: Bem-vindo ao nosso consultório",
      "scheduler-available": "Habilitar Agendador",
      "scheduler-available-description": "Permitir que os pacientes marquem consultas através do terminal de autoatendimento",
      "prescription-available": "Habilitar serviço de prescrição",
      "prescription-available-description": "Patients can request repeat prescriptions at the self-service terminal. The practice reviews every request.",
      "welcome-hint": "Deixe vazio para cumprimentar os pacientes no seu idioma. O seu próprio texto é mostrado sem alterações em todos os idiomas."
    },
    "patient-info": {
      "eyebrow": "Patient information review",
      "description": "Applies practice-wide to every FrontDesk+ terminal and is enforced by the server.",
      "enabled": "Show the review after reading the health card",
      "phone": "Review telephone numbers",
      "email": "Review email addresses",
      "hausarzt": "Review primary physician",
      "selection-required": "Select at least one item to review.",
      "save": "Save review setting",
      "saved": "Review settings saved.",
      "conflict": "The setting changed in the meantime. The current version has been loaded.",
      "save-error": "The review settings could not be saved.",
      "unavailable": "The practice-wide setting is currently unavailable.",
      "scope": "Practice-wide · Server",
      "scope-description": "Stored on the practice server and enforced for all terminals.",
      "sentence-off": "The review is switched off. Patients are not asked about their contact details at the terminal.",
      "last-saved": "Last saved on the server: {{value}}",
      "never-saved": "Never saved on the server.",
      "last-saved-all": "Guardado para todos os dispositivos em {{value}}",
      "never-saved-default": "Definição predefinida, ainda não alterada."
    },
    "anamnesis": {
      "title": "Histórico Médico Digital",
      "description": "Mostra um link e QR code para seu provedor de histórico médico após o check-in.",
      "enabled": "Mostrar link do histórico médico após o check-in",
      "enabled-description": "Mostra um link e QR code para seu provedor de histórico médico após um check-in concluído, por exemplo Nelly.",
      "url": "Link do provedor de histórico médico",
      "url-hint": "O link é estático e idêntico para todos os pacientes.",
      "preview-label": "Visualização da tela de conclusão",
      "preview-note": "O link é estático e idêntico para todos os pacientes.",
      "url-first": "Introduza primeiro uma ligação válida para ativar."
    },
    "appearance": {
      "title": "Aparência",
      "description": "Personalizar a interface do utilizador",
      "language": "Idioma",
      "default-kiosk-language": "Idioma padrão do paciente",
      "default-kiosk-language-hint": "Idioma em que as novas sessões do quiosque são iniciadas para os pacientes.",
      "voice-over-volume": "Volume da narração",
      "voice-over-hint": "Controla o volume do assistente de narração para acessibilidade.",
      "language-first": "Mostrar seleção de idioma no início da sessão"
    },
    "security": {
      "title": "Segurança",
      "description": "PIN para aceder às configurações",
      "pin": "PIN",
      "pin-hint": "4-8 digits. At least 4 digits, and not 0000."
    },
    "eyebrow": "Administração do quiosque",
    "nav": {
      "general": "Geral",
      "flows": "Funções",
      "anamnese": "Anamnese digital",
      "device": "Dispositivo e ligação"
    },
    "flows": {
      "title": "Funções no terminal"
    },
    "language": {
      "title": "Idioma e voz",
      "description": "Idioma e leitura em voz alta para os pacientes neste dispositivo."
    }
  },
  "self-service": {
    "title": "Self-Service",
    "step-progress": "Etapa {{current}} / {{total}}",
    "flows": {
      "checkin": "Check-in",
      "scheduler": "Marcar Consulta",
      "prescription": "Prescrições",
      "locations": "Mapa de Localização",
      "emergency": "Emergência"
    },
    "audio-guide": {
      "on": "Som ligado",
      "off": "Som desligado",
      "replay": "Repetir orientações",
      "replay-unavailable": "Não há orientações de voz para repetir"
    },
    "language-selector": {
      "title": "Selecionar idioma",
      "description": "Por favor selecione o seu idioma preferido"
    },
    "settings": "Configurações",
    "start": {
      "welcome": "Bem-vindo",
      "subtitle": "Por favor selecione uma opção",
      "check-in-label": "Caminho principal",
      "check-in-cta": "Check-in",
      "check-in-description": "Já tem uma consulta? Faça o check-in aqui.",
      "check-in-hint": "Tenha seu cartão em mãos",
      "scheduler-label": "Novo",
      "scheduler-cta": "Marcar Consulta",
      "scheduler-description": "Agende uma nova consulta.",
      "location-plan": "Mapa de Localização",
      "location-plan-description": "Encontre o caminho para a sala de tratamento.",
      "prescription-label": "Prescrição",
      "prescription-cta": "Prescrições e pedidos",
      "prescription-description": "Visualize prescrições ou solicite recargas.",
      "emergency-cta": "Alerta de emergência local",
      "emergency-description": "Só soa neste dispositivo e não chama ajuda.",
      "tap-to-start": "Toque para começar"
    },
    "offline": {
      "banner-title": "Check-in temporariamente indisponível",
      "banner-message": "Por favor, fale com a equipe da recepção para obter assistência.",
      "emergency-available": "O alerta local continua disponível. Não chama ajuda.",
      "flow-disabled": "Temporariamente indisponível"
    },
    "readability": {
      "toggle-label": "Modo de leitura",
      "on": "Modo de leitura",
      "off": "Modo de leitura"
    },
    "reset-overlay": {
      "timeout-title": "Sessão encerrada",
      "timeout-subtitle": "Seu tempo expirou. Seus dados estão seguros.",
      "offline-title": "Conexão perdida",
      "offline-subtitle": "A conexão foi interrompida. Por favor fale com o pessoal da recepção.",
      "interruption-title": "Sessão encerrada",
      "interruption-subtitle": "Sua sessão foi encerrada com segurança.",
      "completion-title": "Obrigado!",
      "completion-subtitle": "Sua solicitação foi concluída com sucesso.",
      "reassurance": "Seus dados pessoais não são armazenados neste dispositivo.",
      "auto-dismiss": "Voltando ao início em {{seconds}} segundos...",
      "dismiss": "Ir para começar"
    },
    "timed-terminal": {
      "countdown": "Retorno automático em segundos {{seconds}}",
      "countdown-outcome": "Este terminal retornará automaticamente à tela inicial.",
      "more-time": "Mais tempo",
      "extended": "Prazo prorrogado"
    },
    "scheduler": {
      "questionnaire": {
        "language-unavailable": "Estas perguntas não estão disponíveis no seu idioma. Escolha um dos idiomas apresentados ou contacte a receção.",
        "alternatives": "Consultas alternativas",
        "loading": "A carregar perguntas…",
        "reception-fallback": "Dirija-se à receção.",
        "error-title": "Não foi possível carregar as perguntas",
        "language-unavailable-lead": "Estas perguntas não estão disponíveis no seu idioma.",
        "language-unavailable-title": "Escolha um destes idiomas",
        "language-unavailable-body": "Ou peça ajuda na receção."
      },
      "start": {
        "title": "Marcar Consulta",
        "subtitle": "Marque a sua consulta preferida em poucos passos",
        "welcome": "Bem-vindo à Marcação de Consultas",
        "description": "Vamos guiá-lo através do processo de marcação",
        "cta": "Marcar consulta agora"
      },
      "patient-id": {
        "title": "Identificação",
        "subtitle": "Por favor identifique-se",
        "mode-card": "Com cartão",
        "mode-search": "Pesquisar",
        "mode-create": "Criar novo",
        "insert-card": "Por favor insira o seu cartão de seguro",
        "reading-card": "A ler cartão...",
        "simulate-card": "Simular cartão",
        "multiple-matches": "Vários pacientes encontrados. A usar dados do cartão.",
        "search-placeholder": "Nome ou número de seguro...",
        "searching": "A pesquisar...",
        "no-results": "Nenhum resultado encontrado",
        "first-name": "Primeiro nome",
        "last-name": "Apelido",
        "dob": "Data de nascimento",
        "insurance": "Seguro",
        "continue": "Continuar",
        "creating": "Criando paciente...",
        "patient-created": "Paciente criado com sucesso!",
        "create-error": "Não foi possível criar o paciente."
      },
      "appointment-type": {
        "title": "Selecionar Tipo de Consulta",
        "subtitle": "Por favor selecione o motivo da sua visita",
        "loading": "A carregar tipos de consulta...",
        "no-types": "Nenhum tipo de consulta disponível",
        "error": "Não foi possível carregar os tipos de consulta. Por favor tente novamente.",
        "no-bookable": "Estes tipos de consulta não podem ser agendados no quiosque neste momento. Dirija-se à receção ou marque por telefone.",
        "disabled-default": "Agende esta consulta diretamente na receção ou por telefone.",
        "disabled-footer": "Só receção/telefone",
        "lead": "Que tipo de consulta deseja marcar?",
        "duration": "aprox. {{minutes}} minutos",
        "empty-title": "De momento não é possível marcar consultas aqui",
        "none-bookable-title": "Estas consultas não podem ser marcadas aqui",
        "none-bookable-body": "Pergunte na receção ou ligue-nos."
      },
      "types": {
        "general": "Consulta Geral",
        "general-desc": "Para queixas e questões gerais",
        "checkup": "Check-up Preventivo",
        "checkup-desc": "Exames de saúde regulares",
        "vaccination": "Vacinação",
        "vaccination-desc": "Agendar uma vacinação",
        "followup": "Acompanhamento",
        "followup-desc": "Consulta de controlo",
        "prescription": "Receita",
        "prescription-desc": "Levantamento de receita"
      },
      "slot-selection": {
        "title": "Selecionar Consulta",
        "subtitle": "Por favor selecione uma consulta disponível",
        "loading": "A carregar consultas disponíveis...",
        "no-slots": "Nenhuma consulta disponível",
        "no-appointment-type": "Nenhum tipo de consulta selecionado",
        "error": "Não foi possível carregar os horários disponíveis. Por favor tente novamente.",
        "quick-select": "Próximas consultas disponíveis:",
        "select-date": "Ou selecione uma data:",
        "times-for": "{{date}}",
        "available": "Disponível",
        "unavailable": "Sem horários",
        "slots": "horários",
        "select-time-hint": "Toque num horário para marcar a sua consulta",
        "week-short": "Sem",
        "weekday-mon": "Seg",
        "weekday-tue": "Ter",
        "weekday-wed": "Qua",
        "weekday-thu": "Qui",
        "weekday-fri": "Sex",
        "weekday-sat": "Sáb",
        "weekday-sun": "Dom",
        "period-morning": "Manhã",
        "period-midday": "Meio-dia",
        "period-afternoon": "Tarde",
        "period-evening": "Noite",
        "period-morning-short": "Manhã",
        "period-midday-short": "Meio-dia",
        "period-afternoon-short": "Tarde",
        "period-evening-short": "Noite",
        "period-dots-legend": "Disponibilidade de horário",
        "filter-hint": "Filtrar por horários preferidos:",
        "or-choose-below": "ou escolha abaixo",
        "no-slots-period": "Sem vagas",
        "show-all": "Mostrar tudo",
        "free": "grátis",
        "your-selection": "Sua seleção",
        "oclock": "horas",
        "choose-slot": "Escolha o slot",
        "choose-day": "Escolher dia",
        "choose-day-first": "Escolha primeiro um dia",
        "times-heading": "Horários livres a {{date}}",
        "time-value": "{{time}}",
        "empty-title": "Sem consultas livres em {{month}}",
        "empty-body": "Veja o mês seguinte ou pergunte na receção – teremos todo o gosto em ajudar.",
        "next-month": "Mês seguinte",
        "previous-month": "Mês anterior"
      },
      "confirmation": {
        "patient-responses": "As suas respostas",
        "review-loading": "A verificar o resumo…",
        "review-unavailable": "Resumo indisponível. Tente novamente ou pergunte na receção.",
        "check-booking": "Verificar a reserva",
        "title": "Confirmar Consulta",
        "subtitle": "Por favor reveja a sua marcação",
        "patient": "Paciente",
        "datetime": "Data e hora",
        "booking": "A marcar...",
        "confirm": "Marcar consulta",
        "heading": "Isso parece certo?",
        "lead": "Por favor confirme a sua marcação.",
        "appointment": "Nomeação",
        "insured-via": "Segurado através",
        "description-label": "Observações para a clínica (opcional)",
        "description-hint": "Informe-nos se devemos considerar algo ao marcar a consulta ou no check-in.",
        "description-placeholder": "ex.: mobilidade reduzida, acompanhante, observações importantes",
        "description-too-long": "Por favor, limite a observação a 500 caracteres.",
        "summary": "Resumo",
        "change": "Alteração",
        "book-binding": "Agendar consulta",
        "cancel": "Cancelar",
        "type-label": "Tipo de consulta",
        "datetime-value": "{{date}} às {{time}}",
        "name-label": "Nome",
        "insurance-label": "Seguro",
        "insurance-GKV": "Seguro de saúde público",
        "insurance-PKV": "Seguro de saúde privado",
        "insurance-SELFPAY": "Pagamento próprio",
        "change-time": "Alterar consulta",
        "description-free-text": "Outras observações (opcional)",
        "note-wheelchair": "Uso cadeira de rodas",
        "note-companion": "Venho acompanhado/a",
        "note-interpreter": "Preciso de um intérprete"
      },
      "done": {
        "title": "Consulta Marcada!",
        "label": "Reservado",
        "subtitle": "A sua consulta foi marcada com sucesso.",
        "date": "Data",
        "time": "Hora",
        "booking-id": "Número de marcação",
        "qr-hint": "Adicionar ao seu calendário",
        "qr-description": "Digitalize este código QR com a câmara do seu smartphone para adicionar a consulta à sua aplicação de calendário",
        "auto-redirect": "Será redirecionado para a página inicial em breve...",
        "auto-redirect-countdown": "A voltar ao início em {{seconds}} segundos...",
        "back-to-start": "Voltar ao início",
        "print-button": "Imprimir comprovativo da consulta",
        "print-preparing": "A preparar a vista de impressão…",
        "print-error": "Não foi possível abrir o comprovativo da consulta. Tente novamente ou peça ajuda na receção.",
        "print-returned": "A vista de impressão do sistema foi fechada. Pode pedir outra cópia se necessário.",
        "print-title": "A sua consulta",
        "print-location": "Local",
        "print-map-hint": "Abrir o local no telemóvel",
        "print-error-v2": "Não foi possível abrir o comprovativo da consulta. Tente novamente ou pergunte na receção."
      },
      "error": {
        "assistance-info": "Não conseguimos confirmar a sua marcação. A sua consulta pode já estar marcada. Pergunte na receção.",
        "pending-title": "Marcação não confirmada",
        "pending-info": "Não conseguimos confirmar a sua marcação. A sua consulta pode já estar marcada. Verifique novamente ou pergunte na receção.",
        "title": "Marcação Falhada",
        "subtitle": "A consulta não pôde ser marcada.",
        "info": "Tente novamente ou pergunte na receção."
      },
      "phase": {
        "identify": "Identificar-se",
        "choose": "Escolher hora",
        "confirm": "Confirmar"
      }
    },
    "prescription": {
      "start": {
        "title": "Prescrições e pedidos",
        "subtitle": "Insira seu cartão de seguro para visualizar prescrições ou solicitar recargas.",
        "button": "Inserir cartão"
      },
      "card-check": {
        "loading": "Carregando leitor de cartão...",
        "no-terminal": "Nenhum leitor de cartão configurado",
        "no-terminal-hint": "Entre em contato com a equipe para obter assistência.",
        "insert-card": "Insira seu cartão",
        "insert-card-hint": "Insira o seu cartão de seguro no leitor de cartões.",
        "card-detected": "Cartão detectado",
        "reading": "Leitura do cartão...",
        "reading-hint": "Aguarde um momento.",
        "error": "Erro ao ler o cartão",
        "retry": "Tente novamente",
        "manual-lookup": "Continuar sem cartão",
        "load-error": "Não foi possível carregar o leitor de cartão",
        "read-error": "O cartão não pôde ser lido"
      },
      "patient-selection": {
        "title": "Selecionar paciente",
        "subtitle": "Vários pacientes foram encontrados. Por favor selecione seu nome.",
        "try-again": "Tente novamente",
        "try-again-hint": "Insira o cartão novamente"
      },
      "list": {
        "title": "Suas prescrições",
        "for-patient": "Prescrições para {{name}}",
        "loading": "Carregando prescrições...",
        "error-title": "Erro de carregamento",
        "fetch-error": "Não foi possível carregar as prescrições",
        "back-home": "Voltar ao início",
        "done": "Concluído"
      },
      "detail": {
        "prescription-info": "Informações sobre prescrição",
        "date": "Data",
        "prescriber": "Prescritor",
        "comment": "Nota",
        "medications": "Medicamentos",
        "form": "Formulário",
        "pack-size": "Tamanho do pacote",
        "manufacturer": "Fabricante",
        "loading": "Carregando prescrição...",
        "fetch-error": "Os detalhes da prescrição não puderam ser carregados",
        "back-to-list": "Voltar à lista",
        "print": "Imprimir"
      },
      "types": {
        "public": "Prescrição Pública",
        "private": "Prescrição Privada",
        "long-term": "Prescrição de longo prazo",
        "btm": "Prescrição de Narcóticos",
        "g": "Prescrição Verde",
        "t": "Prescrição T"
      },
      "no-patient": {
        "title": "Paciente não encontrado",
        "subtitle": "Infelizmente não foi encontrado nenhum paciente para este cartão. Entre em contato com a equipe para obter assistência.",
        "try-again": "Tente novamente",
        "back-home": "Voltar ao início",
        "title-v2": "Nenhum dado correspondente",
        "subtitle-v2": "Não conseguimos encontrá-lo. Tente novamente ou pergunte na receção."
      },
      "done": {
        "title": "Obrigado",
        "subtitle": "Você pode sentar-se agora. Se você tiver dúvidas, entre em contato com a equipe.",
        "no-prescriptions-title": "Nenhuma prescrição registrada",
        "no-prescriptions-subtitle": "Não encontramos nenhuma prescrição ativa para você. Se você esperava um, entre em contato com a equipe da recepção.",
        "error-title": "Ocorreu um erro",
        "error-subtitle": "Entre em contato com a equipe para obter mais assistência.",
        "auto-redirect": "Redirecionamento automático em segundos {{seconds}}",
        "finish": "Voltar ao início"
      },
      "hub": {
        "title": "Suas prescrições",
        "for-patient": "Prescrições para {{name}}",
        "loading": "Carregando prescrições...",
        "error-title": "Erro de carregamento",
        "fetch-error": "Não foi possível carregar prescrições",
        "back-home": "Voltar ao início",
        "done": "Concluído",
        "order-button": "Prescrição de Pedido",
        "existing-prescriptions": "Suas prescrições atuais",
        "no-prescriptions": "Nenhuma prescrição ativa encontrada."
      },
      "patient-lookup": {
        "title": "Encontrar Paciente",
        "subtitle": "Digite seu nome e data de nascimento.",
        "last-name": "Sobrenome",
        "first-name": "Nome",
        "date-of-birth": "Data de Nascimento",
        "lastname": "Sobrenome",
        "lastname-placeholder": "Seu sobrenome",
        "firstname": "Nome",
        "firstname-placeholder": "Seu primeiro nome",
        "dob": "Data de Nascimento",
        "search": "Pesquisa",
        "searching": "Procurando...",
        "search-error": "Erro de pesquisa: {{message}}",
        "no-match": "Nenhum paciente encontrado. Por favor, verifique suas informações.",
        "error": "Erro de pesquisa. Por favor, tente novamente.",
        "found": "Paciente encontrado",
        "confirm": "Confirmar",
        "ambiguous": "Múltiplas correspondências",
        "ambiguous-hint-firstname": "Digite também seu primeiro nome para refinar a pesquisa.",
        "ambiguous-hint-additional": "Verifique suas informações ou entre em contato com a equipe.",
        "not-found": "Paciente não encontrado",
        "not-found-hint": "Nenhum paciente foi encontrado com esses detalhes.",
        "not-found-action": "Tente novamente"
      },
      "manual-identification": {
        "unverified": "A sua identidade não foi confirmada com o cartão de saúde. O consultório verificará os seus dados e o pedido antes de o processar."
      },
      "medication-selection": {
        "title": "Solicitar uma receita",
        "subtitle": "O consultório analisa o seu pedido. Depois de aprovado, o eRx estará pronto no seu app e-prescription.",
        "back": "Voltar",
        "submit": "Continuar a revisão",
        "reason-title": "Por que você precisa da receita?",
        "reason-hint": "Ajuda o consultório a avaliar o seu pedido.",
        "reason-validation": "Escolha um motivo.",
        "reason-schmerzen": "Dor",
        "reason-entzuendung": "Inflamação",
        "reason-nachsorge": "Após cirurgia procedimento /",
        "reason-allergie": "Reação alérgica /",
        "reason-chronisch": "Condição crônica",
        "reason-anderes": "Outra coisa",
        "medications-title": "Quais medicamentos?",
        "request-hint": "Descreva o que você precisa ou nomeie a prescrição anterior que deseja renovar.",
        "request-placeholder": "por ex. Ibuprofeno 600 mg, igual à última vez",
        "request-validation": "Descreva qual medicamento você precisa.",
        "history-title": "Prescrições anteriores",
        "history-hint": "Adicione uma entrada para preencher previamente sua solicitação.",
        "history-loading": "Carregando prescrições anteriores...",
        "history-error": "Não foi possível carregar prescrições anteriores.",
        "history-add": "Adicionar",
        "history-added": "Adicionado",
        "history-date": "Último: {{date}}",
        "history-request-line": "Renovar: {{medicationName}}",
        "urgency-title": "Qual é a urgência?",
        "urgency-hint": "Ajuda o consultório a definir a prioridade.",
        "urgency-soon": "Urgente",
        "urgency-soon-meta": "O mais rápido possível",
        "urgency-tomorrow": "Em breve",
        "urgency-tomorrow-meta": "Nos próximos dias",
        "urgency-week": "Esta semana",
        "urgency-week-meta": "Sem pressão de tempo",
        "lead": "O consultório analisa o seu pedido. Após a aprovação, encontra a sua receita eletrónica na app de receitas eletrónicas ou no seu cartão de saúde.",
        "history-hint-v2": "Toque numa receita anterior para a adicionar.",
        "history-retry": "Carregar novamente"
      },
      "request-review": {
        "title": "Revisão do pedido",
        "subtitle": "Revise seu pedido de prescrição.",
        "request-label": "Medicação solicitada",
        "selected-medications": "Medicamentos Selecionados",
        "free-text-medications": "Medicamentos Adicionais",
        "freetext-label": "Outros",
        "quarterly-warning": "O seu cartão do seguro não foi lido neste trimestre. O consultório pode entrar em contato.",
        "egk-warning": "O seu cartão do seguro não foi lido neste trimestre. O consultório pode entrar em contato.",
        "submit": "Enviar",
        "submitting": "Enviando...",
        "submit-error": "Não foi possível enviar a solicitação. Por favor, tente novamente.",
        "back": "Voltar",
        "reason-label": "Razão",
        "urgency-label": "Urgência",
        "completion-email-choice": "Quero receber um e-mail quando o consultório tiver processado o meu pedido.",
        "completion-email-label": "Endereço de e-mail",
        "completion-email-placeholder": "nome@exemplo.pt",
        "completion-email-hint": "Apenas para esta mensagem única. O endereço não é guardado nos dados principais.",
        "completion-email-invalid": "Introduza um endereço de e-mail válido.",
        "egk-proof-required": "Os pedidos de receita só estão disponíveis após a leitura bem-sucedida do cartão de seguro. Contacte a equipa.",
        "title-v2": "Verificar pedido",
        "completion-email-hint-v2": "O endereço só é usado para esta mensagem."
      },
      "confirmation": {
        "title": "Solicitação enviada",
        "subtitle": "O seu pedido de prescrição foi enviado com sucesso.",
        "success-title": "Solicitação enviada",
        "success-subtitle": "O seu pedido de prescrição foi enviado com sucesso.",
        "estimated-time": "Sua receita estará pronta em aproximadamente {{time}}.",
        "info": "Você pode retirar sua receita na farmácia com seu cartão de seguro ou pelo aplicativo eRezept.",
        "auto-redirect": "Redirecionamento automático em segundos {{seconds}}",
        "back-to-start": "Voltar ao início",
        "handling-label": "Handled by the practice",
        "next-steps": "O consultório analisa o seu pedido. Após a aprovação, pode levantar a sua receita eletrónica na farmácia com o seu cartão de saúde ou a app de receitas eletrónicas."
      },
      "phase": {
        "identify": "Identificar-se",
        "request": "Pedido",
        "review": "Verificar"
      }
    },
    "check-in": {
      "flow-label": "Check-in",
      "has-appointment": {
        "eyebrow": "Nomeação",
        "title": "Tem uma consulta?",
        "subtitle": "Por favor selecione uma opção",
        "yes-label": "Sim",
        "yes": "Sim, tenho uma consulta",
        "yes-description": "Quero fazer o check-in para a minha consulta.",
        "yes-hint": "Caminho mais rápido",
        "unsure-label": "Talvez",
        "unsure": "Não tenho a certeza",
        "unsure-description": "Vamos verificar por si.",
        "unsure-hint": "Procuraremos por você",
        "no-label": "Não",
        "no": "Não, sem consulta",
        "no-description": "Não tenho uma consulta.",
        "no-hint": "Entrada"
      },
      "card-check": {
        "eyebrow": "Cartão de seguro",
        "title": "Ler Cartão de Seguro",
        "subtitle": "Por favor insira o seu cartão de seguro no leitor",
        "insert-title": "Insira o cartão de seguro de saúde no leitor.",
        "insert-detail": "Lemos seus dados automaticamente — você não precisa fazer mais nada.",
        "other-ways": "Outras formas",
        "no-card-hint": "Se você não tiver seu cartão com você agora.",
        "pkv-hint": "Use o QR code com seu aplicativo de seguro.",
        "loading": "A carregar configurações...",
        "no-terminal": "Nenhum leitor de cartões configurado. Por favor contacte o pessoal.",
        "checking": "A verificar cartões...",
        "insert-prompt": "Por favor insira o cartão...",
        "card-detected": "Cartão detetado! Pronto para ler.",
        "read-card": "Ler Cartão",
        "simulate-insert": "Simular cartão",
        "reading": "A ler cartão...",
        "error": "Não foi possível ler o cartão. Por favor tente novamente.",
        "read-error": "Falha ao ler os dados do cartão. Por favor tente novamente.",
        "settings-error": "Não foi possível carregar as configurações. Por favor tente novamente.",
        "no-card-prompt": "Não tem o cartão consigo?",
        "no-card-action": "Pesquisa manual",
        "connection-warning": "Problemas de conexão com leitor de cartão. Por favor, espere...",
        "pkv-prompt": "Seguro privado? Online Check-in",
        "pkv-instruction": "Digitalize este QR code com seu aplicativo de seguro saúde privado para transmitir seus dados digitalmente.",
        "pkv-continue": "Continuar com o registro manual",
        "unreadable-title": "Card detected, but no insurance data could be read.",
        "unreadable-body": "Please try again or go to the reception desk. You can also check in without your card.",
        "unreadable-help": "Tente novamente ou registe-se sem cartão. A receção ajuda com gosto.",
        "title-pkv": "Registo com a app",
        "title-reading": "A ler o seu cartão …",
        "title-unreadable": "Não foi possível ler o cartão",
        "title-no-terminal": "Registo sem cartão",
        "no-terminal-body": "O leitor de cartões não está disponível de momento. Registe-se sem cartão ou dirija-se à receção.",
        "reading-detail": "Deixe o cartão no leitor. Demora só um momento.",
        "other-ways-title": "Outras opções",
        "no-card-title": "Registar-se sem cartão",
        "pkv-prompt-title": "Tem seguro privado?",
        "pkv-prompt-hint": "Registo com a app do seu seguro de saúde privado",
        "pkv-close": "Usar o cartão afinal",
        "pkv-instruction-app": "Abra a app do seu seguro de saúde privado e leia este código. Os seus dados chegam-nos diretamente."
      },
      "patient-selection": {
        "title": "Selecionar Paciente",
        "subtitle": "Vários pacientes encontrados. Por favor selecione-se a si próprio.",
        "firstname-label": "Seu primeiro nome",
        "firstname-placeholder": "Insira o primeiro nome...",
        "confirm-button": "Confirmar",
        "no-match": "Nenhum paciente correspondente encontrado. Por favor, dirija-se à recepção para obter assistência.",
        "still-ambiguous": "Restam várias correspondências. Por favor, dirija-se à recepção para obter assistência.",
        "select-error": "Falha ao identificar o paciente. Por favor, tente novamente.",
        "staff-assist": "Vá para a recepção",
        "title-v2": "Uma pergunta rápida",
        "subtitle-v2": "Por segurança, introduza o seu nome próprio.",
        "no-match-v2": "Não o encontrámos com este nome próprio. Verifique a ortografia ou dirija-se à receção.",
        "still-ambiguous-v2": "Ainda não conseguimos identificá-lo com clareza. Dirija-se à receção.",
        "select-error-v2": "Infelizmente não funcionou. Tente novamente."
      },
      "card-checkin": {
        "title": "Confirmar Check-in",
        "subtitle": "Os seus dados foram lidos com sucesso.",
        "confirm": "Confirmar check-in"
      },
      "register-from-card": {
        "title": "Novo Registo",
        "subtitle": "Ainda não está no nosso sistema. Gostaria de se registar?",
        "card-data": "Dados do cartão",
        "create": "Registar",
        "create-error": "Falha no registro. Tente novamente ou peça ajuda à equipe.",
        "staff-assist": "Chamar Pessoal",
        "no-card-data-title": "Sem dados do cartão",
        "no-card-data": "Não é possível ler os dados do seu cartão.",
        "insurance-verified": "Seguro verificado: {{insurer}}",
        "insurer-missing": "The card does not contain a cost-carrier identifier. Registration via the card is not possible. Please go to the reception desk.",
        "title-v2": "Os seus dados do cartão",
        "subtitle-v2": "Verifique os seus dados. Se algo não estiver certo, toque em «Alterar».",
        "create-v2": "Confirmar dados",
        "create-error-v2": "O registo infelizmente não funcionou. Tente novamente ou dirija-se à receção.",
        "insurer-missing-v2": "O seu cartão não indica a sua seguradora de saúde. Dirija-se à receção.",
        "edit": "Alterar",
        "name": "Nome",
        "insurer": "Seguradora de saúde"
      },
      "patient-lookup": {
        "title": "Pesquisar Paciente",
        "subtitle": "Por favor insira o seu nome ou número de seguro.",
        "lastname": "Sobrenome",
        "lastname-placeholder": "Seu sobrenome",
        "dob": "Data de nascimento",
        "firstname": "Nome",
        "firstname-placeholder": "Seu primeiro nome",
        "search": "Pesquisa",
        "searching": "Procurando...",
        "search-placeholder": "Nome ou número de seguro...",
        "results-placeholder": "Os resultados da pesquisa aparecerão aqui",
        "found": "Paciente encontrado!",
        "confirm-identity": "Por favor, confirme que você é o paciente mostrado.",
        "confirm-button": "Esse sou eu",
        "ambiguous-firstname": "Vários pacientes foram encontrados. Por favor, digite seu primeiro nome.",
        "ambiguous-additional": "Vários pacientes foram encontrados. Entre em contato com a equipe.",
        "disambiguation-hint": "Isso nos ajuda a identificá-lo claramente.",
        "not-found": "Nenhum paciente foi encontrado com esses dados.",
        "error": "Erro de pesquisa: {{message}}",
        "staff-assist": "Chamar a equipe",
        "not-found-prompt": "Não encontrado?",
        "register-new": "Registar novo",
        "not-found-hint": "No patient could be found with these details.",
        "create-new": "Register new patient",
        "dob-placeholder": "DD.MM.YYYY",
        "dob-picker": "Choose date of birth in the calendar",
        "title-v2": "Registo sem cartão",
        "subtitle-firstname": "Introduza também o seu nome próprio.",
        "ambiguous-firstname-v2": "Há várias pessoas com este apelido. Introduza também o seu nome próprio.",
        "search-again": "Pesquisar novamente",
        "found-v2": "Encontrámo-lo",
        "found-confirm": "Confirme com «Sou eu».",
        "not-found-title": "Não o encontrámos",
        "not-found-check": "Verifique a ortografia e a data de nascimento. A receção ajuda com gosto.",
        "not-found-reception": "Verifique a ortografia e a data de nascimento ou dirija-se à receção.",
        "ambiguous-additional-v2": "Não conseguimos identificá-lo com clareza. Dirija-se à receção.",
        "error-v2": "A pesquisa não funcionou de momento. Tente novamente."
      },
      "checking-in": {
        "title": "Um momento — estamos fazendo seu check-in.",
        "subtitle": "Estamos adicionando você à fila de tratamento e notificando a equipe.",
        "step-insurance": "Seguro verificado",
        "step-appointment": "Nomeação confirmada",
        "step-waitlist": "Adicionando à lista de espera",
        "error": "Falha no check-in. Por favor, tente novamente.",
        "continue": "Continuar mesmo assim",
        "title-v2": "Um momento, por favor",
        "loading": "Estamos a registá-lo …",
        "subtitle-v2": "Vamos colocá-lo na lista de espera e avisar a equipa.",
        "error-title": "Infelizmente não funcionou",
        "error-v2": "Não foi possível concluir o seu registo.",
        "error-body": "Tente novamente. Se continuar a não funcionar, a receção ajuda."
      },
      "appointment-selection": {
        "title": "Selecionar compromisso",
        "subtitle": "Você tem vários compromissos hoje. Por favor escolha um.",
        "checking-in": "Fazendo check-in...",
        "time": "{{time}}",
        "error-v2": "O registo para esta consulta não funcionou. Tente novamente ou dirija-se à receção."
      },
      "no-appointment": {
        "title": "Nenhum compromisso encontrado",
        "subtitle": "Não conseguimos encontrar um horário para você hoje. Por favor, marque uma consulta regular.",
        "book-appointment": "Agendar consulta",
        "book-appointment-description": "Marcar nova consulta através do agendador regular.",
        "staff-assist": "Chamar a equipe",
        "staff-assist-description": "Preciso de ajuda.",
        "booking-disabled": "Appointment booking is currently unavailable",
        "booking-disabled-description": "Please contact the practice team to arrange an appointment.",
        "back-to-start": "Back to start",
        "subtitle-v2": "Hoje não encontrámos nenhuma consulta para si.",
        "book-v2": "Marcar nova consulta",
        "book-v2-description": "Escolha agora um horário livre.",
        "have-appointment": "Tenho uma consulta",
        "have-appointment-description": "A receção ajuda com gosto.",
        "unavailable-title": "Marque consultas na receção, por favor",
        "subtitle-unavailable": "Hoje não encontrámos nenhuma consulta para si. Dirija-se à receção."
      },
      "staff-assist": {
        "title": "Funcionários notificados",
        "subtitle": "Um membro da equipe irá ajudá-lo em breve.",
        "message": "Por favor, espere aqui. Um membro da equipe estará com você em breve.",
        "start-over": "Voltar ao início",
        "auto-redirect": "Voltando ao início em {{seconds}} segundos..."
      },
      "eeb-prompt": {
        "title": "Verificar Seguro",
        "title-failed": "Verificação Falhada",
        "subtitle": "Como gostaria de verificar o seu seguro?",
        "subtitle-failed": "Digitalize o código QR com a sua aplicação de seguro para solicitar a verificação.",
        "verify-card": "Verificar eletronicamente",
        "verify-card-description": "Enviar um pedido ao seu fornecedor de seguro.",
        "select-insurer": "Selecionar seguradora",
        "select-insurer-description": "Seleção manual da sua seguradora.",
        "skip": "Saltar",
        "eyebrow-chip": "Alternativa",
        "eyebrow": "Check-in · comprovante de seguro (eEB)",
        "recommended": "Recomendado",
        "qr-title": "Digitalize com seu aplicativo de seguro",
        "qr-description": "Abra seu aplicativo de seguro saúde e escaneie o código – o eEB é enviado diretamente para nós.",
        "qr-address-label": "Enviar para",
        "title-app": "Comprovativo pela app",
        "subtitle-app": "A sua seguradora também nos pode enviar o comprovativo diretamente. Quando terminar, toque em «Seguinte»."
      },
      "quarterly-check": {
        "title": "Verificação de Seguro",
        "checking": "Estamos a verificar a sua verificação de seguro atual...",
        "error": "A verificação não pôde ser realizada.",
        "title-v2": "O seu seguro",
        "checking-v2": "Estamos a verificar o seu seguro – um momento, por favor.",
        "error-body": "O seu registo está concluído. A receção trata do seu seguro consigo."
      },
      "insurer-prefilled": {
        "title": "O Seu Seguro de Saúde",
        "subtitle": "Por favor confirme o seu seguro para este trimestre.",
        "your-insurance": "O seu seguro",
        "last-read": "Última verificação em {{date}}",
        "quarterly-notice": "Para fins de faturação, precisamos de comprovativo de seguro atual para este trimestre.",
        "confirm-button": "Sim, este é o meu seguro",
        "change-button": "Tenho um seguro diferente",
        "contact-title": "Solicitar comprovante eletrônico de cobertura",
        "contact-description": "Ligue para o seu seguro e solicite um comprovante eletrônico de cobertura para:",
        "contact-patient": "Paciente",
        "contact-kim-address": "Endereço KIM do consultório",
        "contact-phone": "Telefone",
        "question": "É esta a sua seguradora de saúde?",
        "quarterly-notice-v2": "Uma vez por trimestre precisamos de um comprovativo da sua seguradora."
      },
      "insurer-search": {
        "title": "Selecionar Seguro de Saúde",
        "subtitle": "Por favor pesquise e selecione o seu seguro de saúde obrigatório.",
        "placeholder": "Pesquisar seguro...",
        "hint": "Insira pelo menos 2 caracteres para pesquisar.",
        "no-results": "Nenhum seguro encontrado.",
        "no-results-hint": "Verifique a ortografia ou tente uma pesquisa diferente.",
        "label": "Nome da sua seguradora de saúde",
        "search-error-v2": "A pesquisa não funcionou de momento. Tente novamente.",
        "app-alternative": "Prefere usar a app da sua seguradora?"
      },
      "insurer-contact": {
        "title": "Solicitar comprovante de seguro",
        "subtitle": "Escolha uma das seguintes opções.",
        "or": "ou",
        "option-eeb-title": "Solicitar eletronicamente",
        "option-eeb-description": "Se existir o caso de exceção previsto na lei, após o seu consentimento pode entregar o pedido à equipa do consultório.",
        "option-qr-title": "Digitalizar com aplicativo",
        "option-qr-description": "Digitalize o QR code com seu aplicativo de seguro.",
        "option-call-title": "Ligue para você mesmo",
        "option-call-description": "Ligue para o seu seguro e solicite um eEB para este consultório:",
        "phone": "Telefone",
        "phone-not-available": "Número de telefone do seu cartão de seguro",
        "patient-name": "Paciente",
        "practice-kim": "Endereço KIM do consultório",
        "help-notice": "Se tiver algum problema, dirija-se à recepção.",
        "submit-eeb-button": "Solicite agora",
        "contacted-button": "Eu liguei",
        "contacted-button-countdown": "Hora da sua chamada ({{seconds}}s)",
        "go-to-counter-button": "Vá para a recepção",
        "qr-continue-button": "Eu digitalizei",
        "qr-continue-button-countdown": "Tempo para digitalizar ({{seconds}}s)",
        "title-v2": "Comprovativo da sua seguradora de saúde",
        "subtitle-v2": "O mais fácil é com a app da sua seguradora.",
        "subtitle-no-app": "Escolha como a sua seguradora nos deve enviar o comprovativo.",
        "option-eeb-description-v2": "Nós pedimos à sua seguradora por si. Para isso precisamos do seu consentimento.",
        "call-instruction": "Ligue à sua seguradora e peça para enviarem o comprovativo ao nosso consultório.",
        "call-instruction-practice": "Ligue à sua seguradora e peça para enviarem o comprovativo ao consultório {{practice}}.",
        "done-button": "Feito – seguinte",
        "done-button-countdown": "Feito – seguinte (ainda {{seconds}} s)"
      },
      "eeb-consent": {
        "title": "Consentimento",
        "subtitle": "Precisamos do seu consentimento para a verificação eletrónica do seguro.",
        "insurance": "O seu seguro",
        "consent-title": "Consentimento para Verificação Eletrónica do Seguro (eEB)",
        "consent-text": "Compreendo que o meu seguro de saúde transmitirá os meus dados de seguro (por exemplo, nome, data de nascimento, número do seguro) através do serviço de comunicação seguro KIM para o consultório {{practiceName}} como comprovativo de seguro. Dou o meu consentimento para esta transmissão. Estou ciente de que posso revogar este consentimento a qualquer momento sem afetar o meu tratamento.",
        "withdrawal-notice": "Pode revogar este consentimento a qualquer momento.",
        "agree-button": "Concordo",
        "decline-button": "Cancelar",
        "treatment-notice": "O seu tratamento não é afetado por este consentimento.",
        "load-failed": "The consent details could not be loaded. You can scan the QR code with your insurer app instead.",
        "not-available": "This request is not possible here right now. Please speak to reception.",
        "submit-failed": "Your consent could not be saved. Please try again or speak to reception.",
        "title-v2": "Comprovativo da sua seguradora de saúde",
        "summary": "A sua seguradora envia-nos o comprovativo diretamente. Para isso precisamos do seu consentimento.",
        "confirm-first": "Confirme primeiro a declaração."
      },
      "qr-code": {
        "title": "Digitalizar com aplicação de seguro",
        "instruction-1": "Abra a sua aplicação de seguro e digitalize este código QR.",
        "instruction-2": "Em seguida, o consultório receberá automaticamente a verificação do seu seguro.",
        "practice": "Consultório: {{name}}",
        "alternative-hint": "Alternativa: Use a sua aplicação de seguro",
        "instruction-app": "Abra a app da sua seguradora de saúde e leia este código. O comprovativo chega-nos diretamente.",
        "staff-line": "Para a equipa do consultório: {{address}}",
        "staff-line-practice": "Para a equipa do consultório: {{name}} · {{address}}",
        "alternative-app": "Também pode pedir o comprovativo com a app da sua seguradora: abra a app e leia este código."
      },
      "register-basics": {
        "title": "Informações Pessoais",
        "subtitle": "Por favor insira os seus dados.",
        "family-name": "Apelido",
        "given-name": "Primeiro nome",
        "dob": "Data de nascimento",
        "gender": "Género",
        "insurance-type": "Tipo de seguro",
        "insurer-name": "Nome do seu seguro",
        "insurer-name-placeholder": "por ex. Debeka, DKV, Allianz...",
        "gender-required": "Escolha uma opção."
      },
      "register-insurer": {
        "title": "Seguro de Saúde",
        "subtitle": "Por favor selecione o seu seguro de saúde.",
        "search-placeholder": "Pesquisar seguro..."
      },
      "register-details": {
        "title": "Resumo",
        "subtitle": "Por favor reveja as suas informações.",
        "create": "Completar registo",
        "missing-data": "Preencha todos os campos obrigatórios.",
        "create-error": "Falha no registro. Por favor, tente novamente.",
        "policy-number": "Número da apólice (opcional)",
        "policy-number-placeholder": "Seu número de apólice",
        "create-v2": "Concluir registo",
        "policy-number-hint": "Encontra o número no cartão do seu seguro."
      },
      "diff-review": {
        "eyebrow-chip": "Revisão",
        "eyebrow": "Check-in · dados do cartão",
        "title": "Comparação de Dados",
        "subtitle": "Foram encontradas diferenças entre os dados do seu cartão e os nossos registos.",
        "col-current": "Registro atual",
        "col-new": "Novo do cartão",
        "new-badge": "novo",
        "field-fallback": "Campo",
        "note": "Os dados atualizados nos ajudam a faturar corretamente e entrar em contato com você em caso de emergência.",
        "comparison-placeholder": "A comparação será mostrada aqui",
        "confirm": "Confirmar alterações",
        "apply-error": "Os dados não puderam ser aplicados. Por favor, tente novamente.",
        "retry": "Tente novamente",
        "skip": "Continuar mesmo assim",
        "no-changes": "Nenhuma alteração encontrada",
        "title-v2": "Os seus dados mudaram",
        "subtitle-v2": "O seu cartão tem dados mais recentes. Devemos atualizá-los?",
        "confirm-v2": "Atualizar e registar",
        "keep": "Registar sem alterações",
        "col-current-v2": "Antes",
        "col-new-v2": "Novo do cartão",
        "value-yes": "Sim",
        "value-no": "Não"
      },
      "insurance-selection": {
        "title": "Tipo de Seguro",
        "subtitle": "Por favor selecione o seu tipo de seguro.",
        "gkv": "Segurado obrigatório",
        "gkv-description": "Membro de um seguro de saúde obrigatório.",
        "pkv": "Privado ou pagamento próprio",
        "pkv-description": "Segurado privado ou pagamento próprio.",
        "pkv-description-v2": "Seguro de saúde privado, ou paga por conta própria."
      },
      "eeb-request": {
        "title": "Pedido registado",
        "subtitle": "Pode concluir o seu check-in. A resposta de {{insurer}} chegará mais tarde ao consultório.",
        "verifying": "O seu pedido foi aceite para processamento imediato.",
        "success": "O seu pedido foi entregue com segurança à equipa do consultório.",
        "error": "A confirmação do pedido não está disponível.",
        "try-alternative": "Método alternativo",
        "kim-load-error": "Não foi possível carregar o endereço KIM do consultório.",
        "kim-label": "Consultório · KIM",
        "non-blocking-note": "Isto ainda não confirma a receção pela sua seguradora de saúde nem o seu estado de seguro.",
        "auto-continue": "Continua automaticamente dentro de {{seconds}} segundos.",
        "unavailable-title": "Infelizmente não funcionou",
        "unavailable-v2": "Não foi possível registar o seu pedido à seguradora de saúde.",
        "unavailable-body": "Pode pedir o comprovativo com a app da sua seguradora ou tratar disso na receção.",
        "use-app": "Com a app",
        "at-reception": "Tratar na receção"
      },
      "self-pay": {
        "title": "Pagamento Próprio",
        "subtitle": "Será tratado como paciente de pagamento próprio.",
        "info": "Por favor note que será responsável pelos custos do tratamento.",
        "confirm": "Compreendido",
        "title-v2": "Paga por conta própria",
        "subtitle-v2": "Paga o tratamento por conta própria.",
        "insured-after-all": "Afinal tenho seguro"
      },
      "done": {
        "title": "Concluído!",
        "subtitle": "O seu check-in está completo.",
        "finish": "Terminar",
        "done-label": "Concluído",
        "error-label": "Aviso",
        "eyebrow": "Check-in · concluído",
        "queue-label": "Sala de espera",
        "queue-title": "Por favor, sente-se",
        "queue-meta": "Ligaremos para você pessoalmente.",
        "success-title": "Check-in bem-sucedido!",
        "success-subtitle": "Por favor sente-se na sala de espera. Será chamado.",
        "auto-redirect": "Será redirecionado para a página inicial em breve...",
        "auto-redirect-countdown": "Voltando ao início em {{seconds}} segundos...",
        "card-expired-title": "Cartão expirado",
        "card-expired-subtitle": "O seu cartão de seguro expirou.",
        "card-expired-info": "Por favor contacte o pessoal para assistência.",
        "back-to-start": "Voltar ao início",
        "anamnesis-title": "Formulário completo de histórico médico",
        "anamnesis-description": "Digitalize o QR code para preencher seu formulário de histórico médico de forma conveniente em seu smartphone.",
        "title-confirm": "Thank you!",
        "subtitle-confirm": "You have confirmed your details. Your check-in is complete — please take a seat in the waiting room.",
        "title-saved": "Thank you!",
        "subtitle-saved": "Your changes have been processed. Reception will get in touch if anything is open. Please take a seat in the waiting room.",
        "title-skip": "Skipped",
        "subtitle-skip": "No problem — your check-in is complete. You can tell reception about changes at any time.",
        "title-v2": "Está registado",
        "card-expired-info-v2": "Dirija-se à receção, por favor."
      },
      "patient-info": {
        "loading": "Loading your contact details …",
        "review": {
          "title": "Review contact details",
          "intro": "Are these details still correct? The review is voluntary — your check-in is already complete.",
          "no-contacts": "No telephone numbers or email addresses are on file.",
          "all-correct": "Everything is correct",
          "skip": "Skip",
          "primary": "Primary",
          "protected": "Reception will review any change to this contact.",
          "reveal": "Show",
          "hide": "Hide",
          "type": {
            "MOBILEPRIV": "Mobile (private)",
            "PHONEPRIV": "Phone (private)",
            "MOBILEJOB": "Mobile (work)",
            "PHONEJOB": "Phone (work)",
            "EMAILPRIV": "Email (private)",
            "EMAILJOB": "Email (work)"
          },
          "save": "Save",
          "save-failed": "Could not save — please speak to reception.",
          "delete": "Delete",
          "undo": "Undo",
          "invalid": "Please check the format.",
          "add": "Add",
          "add-title": "Add a contact",
          "add-type": "Type",
          "add-value": "Enter a value",
          "hausarzt": "Family doctor / GP",
          "hausarzt-placeholder": "Enter a name or practice",
          "hausarzt-reception": "Reception will review any change to this information.",
          "hausarzt-invalid": "Enter no more than 120 characters.",
          "category": {
            "phone": "Phone",
            "email": "Email",
            "hausarzt": "Family doctor"
          },
          "category-empty": "Not on file",
          "primary-tag": "Main contact",
          "protected-chip": "Protected — reception reviews",
          "chip-direct": "Changes: saved directly",
          "chip-reception": "Changes: reception reviews",
          "chip-staged_one": "{{count}} change pending",
          "chip-staged_other": "{{count}} changes pending",
          "chip-will-add": "Will be added",
          "expand-phone_one": "Show {{count}} more number",
          "expand-phone_other": "Show {{count}} more numbers",
          "expand-email_one": "Show {{count}} more address",
          "expand-email_other": "Show {{count}} more addresses",
          "collapse-phone_one": "Hide additional number",
          "collapse-phone_other": "Hide additional numbers",
          "collapse-email_one": "Hide additional address",
          "collapse-email_other": "Hide additional addresses",
          "change": "Change",
          "close": "Close",
          "staged-removal": "Will be removed — value hidden",
          "stage-add": "Add to list",
          "add-more-phone": "Add another number",
          "add-more-email": "Add another address",
          "invalid-phone": "Please enter a valid phone number.",
          "invalid-email": "Please enter a valid email address.",
          "hausarzt-previous": "previously: {{value}}",
          "hausarzt-counter": "{{count}} / 120",
          "balance-total_one": "{{count}} change",
          "balance-total_other": "{{count}} changes",
          "balance-direct": "{{count}} saved directly",
          "balance-reception": "{{count}} reviewed by reception",
          "proposal-open": "Suggest a new address",
          "proposal-placeholder": "Your suggestion",
          "proposal-discard": "Discard",
          "proposal-hint": "Your suggestion goes to reception — the address is not changed immediately.",
          "title-v2": "Verificar os seus dados",
          "balance-prefix": "Ao guardar:",
          "balance-direct-v2": "Guardado de imediato: {{count}}",
          "balance-reception-v2": "Verificado pela receção: {{count}}",
          "chip-reception-v2": "As alterações são verificadas pela nossa receção",
          "chip-changed": "Alterado: {{count}}",
          "remove": "Remover",
          "example-email": "p. ex. nome@exemplo.pt",
          "example-phone": "p. ex. 912 345 678",
          "intro-v2": "O seu registo está concluído. Estes dados ainda estão corretos? A verificação é opcional.",
          "auto-hide": "Os valores mostrados voltam a ficar ocultos pouco depois."
        },
        "result": {
          "title": "Result",
          "continue": "Continue",
          "outcome": {
            "updated": "Updated",
            "satisfied": "Was already up to date",
            "task-created": "Sent to reception",
            "not-saved": "Not saved yet",
            "pending-retry": "Not saved yet"
          },
          "retry": "Try again",
          "removed": "Was removed",
          "cleared": "Was cleared",
          "task-note": "Nothing was overwritten — reception will get in touch if needed.",
          "not-saved-note": "Nothing was overwritten. Please speak to reception.",
          "banner-unfinished": "One detail has not been saved yet. You can try again directly on that row.",
          "banner-done": "Your details have been processed.",
          "footer": "All other details remain unchanged.",
          "task-note-v2": "Passámos este dado à receção.",
          "banner-done-v2": "Obrigado! Recebemos os seus dados.",
          "footer-v2": "Todos os outros dados ficam como estão."
        },
        "expiry": {
          "notice": "For data protection reasons the review ends in 2 minutes. Your check-in stays complete.",
          "title": "The review has expired",
          "body": "For data protection reasons all displayed and entered values were deleted. Your check-in is still complete — you do not need to repeat anything. You can tell reception about changes at any time.",
          "continue": "To the summary",
          "body-v2": "Por motivos de privacidade fechámos a visualização. O seu registo continua concluído. Pode comunicar alterações à receção a qualquer momento."
        }
      },
      "progress": {
        "identify": "Registar-se",
        "insurance": "Seguro",
        "done": "Concluído"
      },
      "dob-format-hint": "Por exemplo 01.10.1980",
      "dob-required": "Introduza a sua data de nascimento.",
      "insurance-label": {
        "GKV": "Seguro público",
        "PKV": "Seguro privado",
        "SELFPAY": "Pagamento próprio"
      }
    },
    "emergency": {
      "title": "Emergência Aguda!",
      "label": "Emergência",
      "subtitle": "Este alerta só é audível localmente e não chamou ajuda. Em emergências agudas ou potencialmente fatais, ligue 112.",
      "call-emergency": "Chamar Serviços de Emergência (112)",
      "stop-sound": "Parar som",
      "play-sound": "Reproduzir som",
      "back-to-start": "Voltar ao início",
      "headline": "Fale imediatamente com o pessoal da receção. Em caso de perigo de vida, ligue 112."
    },
    "help-reception": "Ajuda de recepção",
    "help-reception-toast": "Por favor contacte a recepção. Estamos felizes em ajudar.",
    "language-entry": {
      "title": "Escolha o seu idioma"
    },
    "loading": "A carregar…",
    "step-progress-label": "Progresso",
    "step-progress-phase": "Seção {{current}} de {{total}}: {{phase}}",
    "step-progress-substep": "Parte {{current}} de {{total}}",
    "step-progress-complete": "Concluído",
    "identification": {
      "title": "Quem é você?",
      "lead": "O mais rápido é com o seu cartão de saúde. Também pode pesquisar pelo seu nome.",
      "lead-card-only": "Insira o seu cartão de saúde no leitor de cartões.",
      "mode-label": "Como deseja identificar-se?",
      "mode-card": "Com cartão",
      "mode-search": "Pesquisar pelo nome",
      "mode-create": "Novo no consultório",
      "card": {
        "loading": "A preparar o leitor de cartões …",
        "checking": "A verificar o leitor de cartões …",
        "insert-title": "Insira o seu cartão de saúde no leitor de cartões.",
        "insert-detail": "Lemos os seus dados automaticamente.",
        "detected": "Cartão detetado",
        "read": "Ler cartão",
        "reading": "A ler o cartão …",
        "reading-hint": "Deixe o cartão no leitor.",
        "no-terminal-title": "Leitor de cartões indisponível",
        "help-with-search": "Pesquise pelo seu nome ou pergunte na receção.",
        "help-reception": "Pergunte na receção – teremos todo o gosto em ajudar.",
        "unreadable-title": "Cartão detetado, mas ilegível",
        "error-title": "Não foi possível ler o cartão",
        "not-unique": "Não conseguimos identificá-lo com clareza com este cartão. Pesquise pelo seu nome ou pergunte na receção.",
        "no-match": "Não encontrámos dados para este cartão. Pesquise pelo seu nome ou pergunte na receção.",
        "without-card": "Continuar sem cartão"
      },
      "lookup": {
        "lead": "Introduza o seu apelido e a sua data de nascimento.",
        "first-name": "Nome próprio",
        "last-name": "Apelido",
        "dob": "Data de nascimento",
        "dob-hint": "Formato: DD.MM.AAAA",
        "search": "Pesquisar",
        "confirm": "Sim, sou eu",
        "found-title": "Encontrámo-lo",
        "found-body": "Confirme que se trata de si.",
        "first-name-needed-title": "Acrescente o seu nome próprio",
        "first-name-needed-body": "Para o encontrarmos com clareza. Depois toque em «Pesquisar».",
        "ambiguous-title": "Não conseguimos encontrá-lo com clareza",
        "ambiguous-body": "Pergunte na receção – teremos todo o gosto em ajudar.",
        "not-found-title": "Nenhum dado correspondente",
        "not-found-body": "Verifique os dados introduzidos.",
        "error-title": "A pesquisa não é possível de momento",
        "error-body": "Tente novamente ou pergunte na receção."
      },
      "create": {
        "insurance-question": "Como está segurado?",
        "insurance-required": "Escolha como está segurado.",
        "error-title": "Não foi possível guardar os seus dados",
        "error-body": "Tente novamente ou pergunte na receção."
      }
    }
  },
  "onboarding": {
    "prepare": {
      "title": "Desbloqueie primeiro",
      "subtitle": "FrontDesk+ deve estar ativado em seu software de prática.",
      "step1": "Faça o pedido em SolStore (ou seus pedidos de parceiros Doc-Cirrus para você).",
      "step2": "Após a ativação, ative em inSuite em “inSuite Sols” (direitos de administrador).",
      "step3": "Abra a administração Bridge → “Adicionar dispositivo”.",
      "cta": "Tudo pronto - siga em frente"
    },
    "welcome": {
      "title": "Adicione este dispositivo à prática",
      "scan": "Tire uma foto do código",
      "prepare-link": "Nenhum código em inSuite?",
      "language": "Linguagem"
    },
    "scan": {
      "requesting": "O acesso à câmera é solicitado…",
      "scanning": "Aponte a câmera para o código",
      "paste": "Cole em vez disso",
      "manual-title": "Conectar manualmente",
      "manual-description": "Se o código QR não estiver disponível, obtenha os dados de conexão da administração Bridge.",
      "address-label": "Endereço Bridge",
      "address-placeholder": "https://…/_rest_",
      "soltoken-label": "SOLTOKEN",
      "soltoken-placeholder": "Insira SOLTOKEN",
      "manual-submit": "Assumir a conexão",
      "error-title": "Código não reconhecido",
      "camera-denied-title": "Acesso à câmera negado",
      "camera-denied-hint": "Permita o acesso à câmera nas configurações e tente novamente.",
      "retry": "Tente novamente"
    },
    "preflight": {
      "title": "Será configurado",
      "all-green": "Todos os testes passaram",
      "practice": "Prática",
      "device-name": "Nome do dispositivo",
      "device-name-placeholder": "por exemplo B. Recepção 1",
      "card-reader": "Leitor de cartão",
      "pin": "Novo número secreto",
      "pin-placeholder": "PIN de quatro dígitos",
      "finish": "Terminar",
      "recheck": "Verifique novamente",
      "diagnosis": "ID de diagnóstico",
      "checklist-error": "O Bridge recusou a ligação ou não está acessível. Verifique o SOLTOKEN e o endereço do Bridge.",
      "checklist-retry": "Verificar novamente",
      "edit-token": "Alterar SOLTOKEN",
      "rescan": "Digitalizar o código novamente"
    },
    "persisting": "A guardar a configuração …",
    "success": {
      "title": "Dispositivo adicionado",
      "detail": "O dispositivo acaba de aparecer no PC de prática.",
      "starting": "O modo paciente está começando…"
    },
    "checklist": {
      "general_api_unavailable": {
        "label": "Conexão com o software de prática",
        "fix": "Bridge Verifique a conexão e o endereço do servidor."
      },
      "missing_insuite_url": {
        "label": "Endereço inSuite",
        "fix": "Digitalize o código QR novamente - o endereço está faltando."
      },
      "missing_server_token": {
        "label": "Token do servidor",
        "fix": "Digitalize o código QR novamente - o token está faltando."
      },
      "missing_gateway_session": {
        "label": "Sessão Gateway",
        "fix": "Faça login novamente – a sessão está faltando."
      },
      "missing_gateway_enrollment": {
        "label": "Registro do dispositivo",
        "fix": "Registre o dispositivo no Gateway."
      },
      "gateway_not_ready": {
        "label": "Prontidão Gateway",
        "fix": "Aguarde até que o Gateway conclua a configuração."
      },
      "token_verification_failed": {
        "label": "Verificação de token",
        "fix": "Verifique o token do servidor ou a conexão Bridge."
      },
      "session_expired": {
        "label": "reunião",
        "fix": "A sessão expirou - faça login novamente."
      },
      "device_revoked": {
        "label": "Status do dispositivo",
        "fix": "Este dispositivo foi bloqueado. Entre em contato com a prática."
      },
      "missing_practice_name": {
        "label": "Nome da prática",
        "fix": "Não foi possível carregar o nome do consultório médico (inSuite)."
      },
      "missing_device_name": {
        "label": "Nome do dispositivo",
        "fix": "Insira um nome de dispositivo."
      },
      "telematik_unavailable": {
        "label": "Infraestrutura telemática",
        "fix": "Opcional — a verificação do cartão continua possível assim que o TI estiver disponível."
      },
      "selected_card_reader_unavailable": {
        "label": "Leitor de cartão",
        "fix": "Opcional — selecione ou conecte um leitor de cartão."
      },
      "medical_card_unavailable": {
        "label": "SMC-B / HBA",
        "fix": "Opcional – insira o cartão de credencial do consultório médico (SMC-B)."
      }
    },
    "token": {
      "title": "Introduzir SOLTOKEN",
      "description": "Por motivos de segurança, o código QR não contém o SOLTOKEN. Copie-o no inSuite em «Sol-Aktivierung» (FrontDesk+) e cole-o aqui.",
      "submit": "Continuar",
      "rescan": "Digitalizar o código novamente"
    }
  }
}
